document.addEventListener('DOMContentLoaded', function () {
  var roots = document.querySelectorAll('[data-rwr-breed-finder]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var selectEl = root.querySelector('.rwr-breed-finder__select');
    var resetBtn = root.querySelector('[data-rwr-breed-reset]');
    var resultEl = root.querySelector('[data-rwr-breed-result]');
    var cardEl = root.querySelector('.rwr-breed-finder__card');

    if (!selectEl || !resetBtn || !resultEl || !cardEl) return;

    var hideEmpty = root.dataset.hideEmpty === 'true';
    var sizeGuideUrl = root.dataset.sizeGuideUrl || '/pages/dog-collar-size-guide-dubai';

    var collarConfig = {
      leather: {
        label: root.dataset.leatherLabel || 'Leather dog collars',
        url: root.dataset.leatherUrl || ''
      },
      upcountry: {
        label: root.dataset.upcountryLabel || 'Up Country dog collars',
        url: root.dataset.upcountryUrl || ''
      },
      sports: {
        label: root.dataset.sportsLabel || 'Sports and active collars',
        url: root.dataset.sportsUrl || ''
      },
      sighthound: {
        label: root.dataset.sighthoundLabel || 'Sighthound collars',
        url: root.dataset.sighthoundUrl || ''
      }
    };

    var breedData = {
      'chihuahua': {
        size: 'Small',
        temperament: 'Alert, lively, can be nervous',
        traits: 'Fine neck and small frame',
        considerations: 'Choose very lightweight, soft collars and avoid bulky hardware.',
        collars: ['upcountry', 'leather']
      },
      'pomeranian': {
        size: 'Small',
        temperament: 'Confident, alert, vocal',
        traits: 'Thick neck ruff and dense coat',
        considerations: 'Smooth, padded collars help prevent matting and coat breakage.',
        collars: ['leather', 'upcountry']
      },
      'shih-tzu': {
        size: 'Small',
        temperament: 'Calm, affectionate companion',
        traits: 'Long, silky coat',
        considerations: 'Use soft, lightweight collars that do not snag or tangle hair.',
        collars: ['upcountry', 'leather']
      },
      'pug': {
        size: 'Small / medium',
        temperament: 'Friendly, charming, can pull hard',
        traits: 'Broad neck, prone to overheating',
        considerations: 'Choose padded collars and avoid narrow fits.',
        collars: ['leather', 'upcountry']
      },
      'poodle-mini': {
        size: 'Small / medium',
        temperament: 'Intelligent, active',
        traits: 'Curly coat can mat easily',
        considerations: 'Smooth, lined collars protect fur.',
        collars: ['leather', 'upcountry']
      },
      'dachshund': {
        size: 'Small',
        temperament: 'Bold, independent',
        traits: 'Long back, shorter neck',
        considerations: 'Avoid wide collars; choose soft, low-sitting fits.',
        collars: ['upcountry', 'leather']
      },
      'cavalier': {
        size: 'Small / medium',
        temperament: 'Gentle, affectionate',
        traits: 'Feathered neck coat',
        considerations: 'Soft padding prevents tangling.',
        collars: ['leather', 'upcountry']
      },

      'french-bulldog': {
        size: 'Small / medium',
        temperament: 'Calm, affectionate',
        traits: 'Broad neck, sensitive throat',
        considerations: 'Use padded collars; avoid narrow straps.',
        collars: ['leather', 'upcountry']
      },
      'cocker-spaniel': {
        size: 'Medium',
        temperament: 'Lively, playful',
        traits: 'Feathered coat and active energy',
        considerations: 'Lining helps prevent rubbing and matting.',
        collars: ['upcountry', 'leather', 'sports']
      },
      'beagle': {
        size: 'Medium',
        temperament: 'Curious, determined',
        traits: 'Prone to pulling',
        considerations: 'Strong hardware recommended.',
        collars: ['sports', 'upcountry']
      },
      'border-collie': {
        size: 'Medium',
        temperament: 'Very active, intelligent',
        traits: 'Needs strong everyday control',
        considerations: 'Durable collars best for working activity.',
        collars: ['sports', 'leather']
      },
      'staffie': {
        size: 'Medium',
        temperament: 'Strong, affectionate',
        traits: 'Broad, muscular neck',
        considerations: 'Wide, strong collars recommended.',
        collars: ['sports', 'leather']
      },
      'saluki': {
        size: 'Medium / large',
        temperament: 'Elegant, sensitive',
        traits: 'Long, slender neck',
        considerations: 'Use wide padded sighthound collars.',
        collars: ['sighthound', 'leather']
      },

      'labrador': {
        size: 'Large',
        temperament: 'Friendly, energetic',
        traits: 'Strong puller, active outdoors',
        considerations: 'Use strong hardware and padded fits.',
        collars: ['sports', 'upcountry', 'leather']
      },
      'golden-retriever': {
        size: 'Large',
        temperament: 'Gentle, playful',
        traits: 'Active, may pull on walks',
        considerations: 'Pressure-spreading collars preferred.',
        collars: ['sports', 'leather', 'upcountry']
      },
      'german-shepherd': {
        size: 'Large',
        temperament: 'Confident, powerful',
        traits: 'High-drive working dog',
        considerations: 'Strong collars essential for control.',
        collars: ['sports', 'leather']
      },
      'belgian-malinois': {
        size: 'Medium / large',
        temperament: 'Very energetic',
        traits: 'Fast, powerful',
        considerations: 'Needs secure collars suited to training.',
        collars: ['sports', 'leather']
      },
      'husky': {
        size: 'Medium / large',
        temperament: 'Strong, energetic',
        traits: 'Strong puller',
        considerations: 'Wide padded collars recommended.',
        collars: ['sports', 'leather']
      },
      'alaskan-malamute': {
        size: 'Large',
        temperament: 'Powerful, energetic',
        traits: 'Very strong puller',
        considerations: 'Wide, strong collars needed.',
        collars: ['sports', 'leather']
      },
      'rottweiler': {
        size: 'Large',
        temperament: 'Strong, confident',
        traits: 'Muscular neck',
        considerations: 'Choose wide collars with strong hardware.',
        collars: ['leather', 'sports']
      },
      'dobermann': {
        size: 'Large',
        temperament: 'Alert, protective',
        traits: 'Strong active breed',
        considerations: 'Secure padded collars preferred.',
        collars: ['sports', 'leather']
      },
      'greyhound': {
        size: 'Large sighthound',
        temperament: 'Gentle, sensitive',
        traits: 'Narrow neck',
        considerations: 'Use wide shaped sighthound collars.',
        collars: ['sighthound', 'upcountry']
      },
      'whippet': {
        size: 'Small / medium sighthound',
        temperament: 'Gentle, athletic',
        traits: 'Fine neck and narrow head',
        considerations: 'Sighthound collars reduce slipping.',
        collars: ['sighthound', 'upcountry']
      },

      'mixed-small': {
        size: 'Small',
        temperament: 'Varied, companion dog',
        traits: 'Light frame',
        considerations: 'Avoid large hardware.',
        collars: ['upcountry', 'leather']
      },
      'mixed-medium': {
        size: 'Medium',
        temperament: 'Varied, active',
        traits: 'Average neck size',
        considerations: 'Adjustable collars recommended.',
        collars: ['upcountry', 'leather', 'sports']
      },
      'mixed-large': {
        size: 'Medium / large',
        temperament: 'Varied, strong',
        traits: 'May need extra control',
        considerations: 'Strong collars required if pulling.',
        collars: ['sports', 'leather', 'upcountry']
      }
    };

    function buildCollarPills(keys) {
      if (!keys || !keys.length) return '';

      return keys
        .map(function (key, index) {
          var config = collarConfig[key];
          if (!config) return '';

          var classes = 'rwr-breed-finder__pill';
          if (index === 0) {
            classes += ' rwr-breed-finder__pill--primary';
          } else {
            classes += ' rwr-breed-finder__pill--secondary';
          }

          if (config.url) {
            return '<a class="' + classes + '" href="' + config.url + '">' +
                     config.label +
                   '</a>';
          }

          return '<span class="' + classes + '">' + config.label + '</span>';
        })
        .join('');
    }

    function renderResult(breedKey) {
      var d = breedData[breedKey];

      if (!d) {
        // Always hide card when there is no breed selected / no data
        cardEl.classList.add('is-hidden');

        resultEl.classList.add('rwr-breed-finder__result--empty');
        resultEl.classList.remove('rwr-breed-finder__result--active');

        if (!hideEmpty) {
          resultEl.innerHTML = '<p>Select a breed to see personalised recommendations.</p>';
        } else {
          resultEl.innerHTML = '';
        }

        if (resetBtn) {
          resetBtn.classList.remove('rwr-breed-finder__reset--visible');
        }
        return;
      }

      // Valid breed selected – show content and card
      resultEl.classList.remove('rwr-breed-finder__result--empty');
      resultEl.classList.add('rwr-breed-finder__result--active');
      cardEl.classList.remove('is-hidden');

      if (resetBtn) {
        resetBtn.classList.add('rwr-breed-finder__reset--visible');
      }

      var pillsMarkup = buildCollarPills(d.collars);

      var footnoteHtml = '';
      if (!hideEmpty) {
        footnoteHtml =
          '<p class="rwr-breed-finder__footnote">' +
            'Always check fit using our <a href="' + sizeGuideUrl + '">size guide</a>.' +
          '</p>';
      }

      resultEl.innerHTML =
        '<div class="rwr-breed-finder__summary">' +
          '<div class="rwr-breed-finder__summary-item">' +
            '<div class="rwr-breed-finder__summary-label">Breed size</div>' +
            '<div class="rwr-breed-finder__summary-value">' + d.size + '</div>' +
          '</div>' +
          '<div class="rwr-breed-finder__summary-item">' +
            '<div class="rwr-breed-finder__summary-label">Temperament</div>' +
            '<div class="rwr-breed-finder__summary-value">' + d.temperament + '</div>' +
          '</div>' +
          '<div class="rwr-breed-finder__summary-item">' +
            '<div class="rwr-breed-finder__summary-label">Key fit note</div>' +
            '<div class="rwr-breed-finder__summary-value">' + d.traits + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="rwr-breed-finder__body">' +
          '<h3 class="rwr-breed-finder__body-title">Recommended collar for your dog</h3>' +
          '<ul class="rwr-breed-finder__bullets">' +
            '<li><strong>Breed traits:</strong> ' + d.traits + '</li>' +
            '<li><strong>Considerations:</strong> ' + d.considerations + '</li>' +
            '<p class="rwr-collar-types-heading">Recommended collar types:</p>' +
          '</ul>' +
          (pillsMarkup
            ? '<div class="rwr-breed-finder__pills-wrap">' +
                '<div class="rwr-breed-finder__pills">' + pillsMarkup + '</div>' +
              '</div>'
            : '') +
          footnoteHtml +
        '</div>';
    }

    function resetSelection() {
      selectEl.value = '';
      renderResult('');
    }

    selectEl.addEventListener('change', function () {
      renderResult(this.value);
    });

    resetBtn.addEventListener('click', resetSelection);

    // Initial state: no breed selected → card hidden
    renderResult('');
  });
});
